import { render, staticRenderFns } from "./addTab.vue?vue&type=template&id=07cc4048"
import script from "./addTab.vue?vue&type=script&lang=js"
export * from "./addTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports